const NavLinkedInIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0801 2.66675H21.9187C26.3538 2.66675 29.3334 5.78534 29.3334 10.4281V21.572C29.3334 26.2134 26.3524 29.3334 21.9173 29.3334H10.0801C5.6464 29.3334 2.66675 26.2134 2.66675 21.572V10.4281C2.66675 5.78534 5.6464 2.66675 10.0801 2.66675ZM9.66675 10.8119C9.66675 10.1797 10.1792 9.66675 10.8119 9.66675C11.4437 9.66675 11.9571 10.1789 11.9571 10.8119C11.9571 11.4448 11.4438 11.957 10.8119 11.957C10.1791 11.957 9.66675 11.444 9.66675 10.8119ZM16.1823 16.5745C16.1823 15.2628 17.2471 14.198 18.5589 14.198C19.8719 14.198 20.9354 15.2625 20.9354 16.5745V21.0681C20.9354 21.6204 21.3831 22.0681 21.9354 22.0681C22.4877 22.0681 22.9354 21.6204 22.9354 21.0681V16.5745C22.9354 14.1585 20.977 12.198 18.5589 12.198C16.1426 12.198 14.1823 14.1582 14.1823 16.5745V21.0681C14.1823 21.6204 14.6301 22.0681 15.1823 22.0681C15.7346 22.0681 16.1823 21.6204 16.1823 21.0681V16.5745ZM11.8113 14.6564C11.8113 14.1041 11.3636 13.6564 10.8113 13.6564C10.259 13.6564 9.81129 14.1041 9.81129 14.6564V21.0674C9.81129 21.6197 10.259 22.0674 10.8113 22.0674C11.3636 22.0674 11.8113 21.6197 11.8113 21.0674V14.6564Z"
        fill="url(#paint0_linear_15183_166102)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_15183_166102"
          x1="16.0001"
          y1="2.66675"
          x2="16.0001"
          y2="29.3334"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#89B8F0" />
          <stop offset="1" stopColor="#165BAD" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default NavLinkedInIcon
